<template>
    <adminTable ref="adminTableRef" :tableLoading="tableLoading" :totalList="totalList" v-model:page="page"
        v-model:limit="limit" v-model:searchForm="searchForm" :tableData="tableData" @search="getList">
        <template v-slot:form-inline-items>
            <el-form-item>
                <el-input v-model="searchForm.keyword" placeholder="搜索股权名称关键字" clearable />
            </el-form-item>
            <el-form-item>
                <el-input v-model="searchForm.username" placeholder="搜索用户" clearable />
            </el-form-item>
            <el-form-item>
                <el-input v-model="searchForm.phone" placeholder="搜索手机号" clearable />
            </el-form-item>
            <el-form-item>
                <el-select v-model="searchForm.side" placeholder="做多/空" clearable>
                    <el-option v-for="item in stocksSideEnums" :label="item.label" :value="item.value"
                        :key="item.label" />
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-select v-model="searchForm.type" placeholder="买卖类型" clearable>
                    <el-option v-for="item in stockOrderTradeTypeEnums" :label="item.label" :value="item.value"
                        :key="item.value" />
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-input v-model="searchForm.order_no" placeholder="搜索订单号" clearable />
            </el-form-item>
            <el-form-item>
                <el-select v-model="searchForm.status" placeholder="状态" clearable>
                    <el-option v-for="item in stockOrderStatusEnums" :label="item.label" :value="item.value"
                        :key="item.label" />
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-col :span="11">
                    <el-date-picker v-model="searchForm.starttime" type="datetime" value-format="YYYY-MM-DD HH:mm:ss"
                        placeholder="开始时间" style="width: 100%" />
                </el-col>
                <el-col :span="2" class="text-center">
                    <span class="text-gray-500">-</span>
                </el-col>
                <el-col :span="11">
                    <el-date-picker v-model="searchForm.endtime" type="datetime" value-format="YYYY-MM-DD HH:mm:ss"
                        placeholder="结束时间" style="width: 100%" />
                </el-col>
            </el-form-item>
        </template>
        <template v-slot:table>
            <el-table-column prop="id" label="ID" width="60" />
            <el-table-column prop="code" label="股权编码" width="160">
                <template #default="scope">
                    <span :style="{ color: scope.row.is_test == 1 ? 'red' : '' }">
                        {{ scope.row.stock.code }}
                    </span>
                </template>
            </el-table-column>
            <el-table-column prop="name" label="名称" width="150">
                <template #default="scope">
                    <span :style="{ color: scope.row.is_test == 1 ? 'red' : '' }">
                        {{ scope.row.stock.name }}
                    </span>
                </template>
            </el-table-column>
            <el-table-column prop="order_no" label="订单号" width="180" />
            <el-table-column prop="side" label="类型" width="80">
                <template #default="scope">
                    <span :style="{ color: scope.row.is_test == 1 ? 'red' : '' }">
                        {{ getLabelByVal(scope.row.side, stocksSideEnums) }}
                    </span>
                </template>
            </el-table-column>
            <el-table-column prop="shares" label="份数" width="100" />
            <el-table-column prop="price" label="成交单价" width="120" />
            <el-table-column prop="amount" label="总额" width="140" />
            <el-table-column prop="username" label="购买人" width="140">
                <template #default="scope">
                    <span :style="{ color: scope.row.is_test == 1 ? 'red' : '' }">
                        {{ scope.row.user?.username }}
                    </span>
                </template>
            </el-table-column>
            <el-table-column prop="phone" label="手机号" width="140">
                <template #default="scope">
                    <span :style="{ color: scope.row.is_test == 1 ? 'red' : '' }">
                        {{ scope.row.user?.phone }}
                    </span>
                </template>
            </el-table-column>
            <el-table-column prop="remark" label="备注" width="100" />
            <el-table-column prop="status" label="审核状态" width="120">
                <template #default="scope">
                    <span :style="{ color: scope.row.is_test == 1 ? 'red' : '' }">
                        {{ getLabelByVal(scope.row.status, stockOrderStatusEnums) }}
                    </span>
                </template>
            </el-table-column>
            <el-table-column prop="create_time" label="添加时间" width="180" />
            <el-table-column label="操作" width="200" fixed="right" v-if="currentUser.role == 0">
                <template #default="scope">
                    <el-button type="info" icon="Message" v-permission @click="info(scope.row, 'info')">查看</el-button>
                    <el-button type="primary" icon="Edit" :disabled="scope.row.status != 0" v-permission
                        @click="info(scope.row, 'exam')">审核</el-button>
                </template>
            </el-table-column>
        </template>
        <el-dialog v-model="dialogFlag" title="订单信息" width="800">
            <!-- 弹窗展示 row 信息 不要form-->
            <el-descriptions :column="2" border>
                <el-descriptions-item label="订单号">{{ infoRow.order_no }}</el-descriptions-item>
                <el-descriptions-item label="股权编码">{{ infoRow.stock.code }}</el-descriptions-item>
                <el-descriptions-item label="名称">{{ infoRow.stock.name }}</el-descriptions-item>
                <el-descriptions-item label="类型">{{ getLabelByVal(infoRow.side, stocksSideEnums)
                }}</el-descriptions-item>
                <el-descriptions-item label="用户">{{ infoRow.user.username }}</el-descriptions-item>
                <el-descriptions-item label="手机号">{{ infoRow.user.phone }}</el-descriptions-item>
                <el-descriptions-item label="份数">{{ infoRow.shares }}</el-descriptions-item>
                <el-descriptions-item label="成交单价">{{ infoRow.price }}</el-descriptions-item>
                <el-descriptions-item label="总额">{{ infoRow.amount }}</el-descriptions-item>
                <el-descriptions-item label="备注">{{ infoRow.remark }}</el-descriptions-item>
                <el-descriptions-item label="签名">
                    <el-image v-if="infoRow.signature.image_url" class="previewImg" :preview-teleported="true"
                        :src="proxy.IMG_BASE_URL + infoRow.signature.image_url" :zoom-rate="1.2" :max-scale="7"
                        :min-scale="0.2" :preview-src-list="[proxy.IMG_BASE_URL + infoRow.signature.image_url]"
                        show-progress :initial-index="0" fit="cover" />
                </el-descriptions-item>
                <el-descriptions-item label="审核状态">{{ getLabelByVal(infoRow.status, stockOrderStatusEnums)
                    }}</el-descriptions-item>
                <el-descriptions-item label="添加时间">{{ infoRow.create_time }}</el-descriptions-item>
                <el-descriptions-item label="更新时间">{{ infoRow.update_time }}</el-descriptions-item>
            </el-descriptions>
            <template #footer>
                <div class="dialog-footer">
                    <el-button @click="dialogFlag = false">关闭</el-button>
                    <template v-if="stocktype == 'exam'">
                        <el-button type="primary" @click="exam('agree')"> 通过 </el-button>
                        <el-button type="primary" @click="exam('refuse')"> 拒绝 </el-button>
                    </template>
                </div>
            </template>
        </el-dialog>
    </adminTable>
</template>

<script setup>
import { ref, getCurrentInstance, onMounted } from "vue";
import { stockOrderStatusEnums, stocksSideEnums, getLabelByVal } from "@/config/enums";
import { getTokenAUTH } from "@/utils/auth";


const currentUser = JSON.parse(sessionStorage.getItem("currentUser"));
const stockOrderTradeTypeEnums = [
    { label: "买入", value: 0 },
    { label: "卖出", value: 1 },
];
const searchForm = ref({
    keyword: "",
    'username': '',
    'phone': '',
    'status': '',
    'side': '',
    'type': '',
    'order_no': '',
    'starttime': '',
    'endtime': '',
});
const adminTableRef = ref(null);
const headers = ref({})

onMounted(() => {
    headers.value['Accept-Token'] = getTokenAUTH()
    getList();
});

const { proxy } = getCurrentInstance();
const stocktype = ref("info");
const dialogFlag = ref(false);
const infoRow = ref({});

const info = async (row, type) => {
    stocktype.value = type;
    const res = await proxy.$http({
        type: "get",
        url: `/Stock/getStockOrderInfo?id=${row.id}`,
    })
    if (res.code == 0) {
        infoRow.value = res.data;
        dialogFlag.value = true;
    }
}

const exam = async (type) => {
    const res = await proxy.$http({
        method: "post",
        url: "/Stock/updateStockOrderStatus",
        data: {
            id: infoRow.value.id,
            status: type == 'agree' ? 1 : 2,
        },
    });
    if (res.code == 0) {
        proxy.$message.success("审核成功");
        dialogFlag.value = false;
        getList();
    }
}

const tableData = ref([]);
const page = ref(1);
const limit = ref(10);
const totalList = ref(0);
const tableLoading = ref(false);

const getList = async () => {
    tableLoading.value = true;
    const res = await proxy.$http({
        type: "get",
        url: "/Stock/getStockOrderLists",
        params: {
            page: page.value,
            limit: limit.value,
            ...searchForm.value,
        },
    });
    tableLoading.value = false;
    if (res.code == 0) {
        tableData.value = res.data.data;
        totalList.value = res.data.total;
    }
};
</script>

<style lang="less" scoped></style>
